export default __webpack_public_path__ + "static/media/Skater_forAE.313a47e5.gif";